import React from "react";

import "./AccordionData.css";

import { Typography, styled } from "@mui/material";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";

const Accordion = styled((props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(() => ({
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    style={{ backgroundColor: "#f9f9f9" }}
    expandIcon={
      <ArrowForwardIosSharpIcon
        sx={{ fontSize: "0.9rem" }}
        style={{ color: "#1352b4", backgroundColor: "#f9f9f9" }}
      />
    }
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  />
))(({ theme }) => ({
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
    color: "#1351b4",
    fontWeight: "bold",
    backgroundColor: "#f9f9f9",
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: "#f9f9f9",
  fontFamily: "'Raleway'",
}));

export function AccordionData() {
  const [expanded, setExpanded] = React.useState("panel1");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <>
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
      >
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <Typography
            style={{
              color: "#1351b4",
              fontWeight: "600",
              fontFamily: "'Raleway'",
            }}
          >
            O que é o HU Digital?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography
            style={{
              color: "#555555",
              fontWeight: "400",
              fontFamily: "'Raleway'",
            }}
          >
            <p>
              O HU Digital é a plataforma da HU Brasil para saúde digital que
              oferece aos pacientes e aos profissionais de saúde dos Hospitais
              Universitários Federais da Empresa Brasileira de Serviços
              Hospitalares HU Brasil, serviços digitais para o acesso aos
              Registros Eletrônicos de Saúde de forma unificada, com o objetivo
              de proporcionar uma visão de saúde integrada com foco na
              continuidade do cuidado e na melhoria da atenção em saúde.
            </p>
            <p>
              Pelo uso das aplicações Portal WEB e aplicativos para dispositivos
              móveis (iOS e Android), o HU Digital disponibilizará, serviços
              digitais para proporcionar o acesso e o consentimento aos
              registros eletrônicos de saúde pelo paciente, permitindo o
              compartilhamento de forma segura e oportuna.
            </p>
            <p>
              Os profissionais de saúde da HU Brasil têm acesso a uma visão
              transversal dos registros eletrônicos de saúde de seus pacientes
              por meio do sistema AGHUX, Portal HU Digital ou aplicativo HU
              Digital, disponível nas lojas de aplicativos Google Play Store e
              Apple Store.
            </p>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
          <Typography
            style={{
              color: "#1351b4",
              fontWeight: "600",
              fontFamily: "'Raleway'",
            }}
          >
            Quais os serviços que estão disponíveis no HU Digital?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography
            style={{
              color: "#555555",
              fontWeight: "400",
              fontFamily: "'Raleway'",
            }}
          >
            <p>
              Na visão do paciente, o HU Digital disponibiliza os Registros
              Eletrônicos de Saúde de seus atendimentos na Rede Hospitalar do HU
              Brasil, permitindo, através do controle de consentimento, o
              compartilhamento dessas informações de forma segura e oportuna,
              com quem desejar, com outros profissionais de saúde ou
              estabelecimentos de saúde de sua confiança.
            </p>
            <p>
              O HU Digital evoluirá para oferecer cada vez mais serviços
              digitais, com objetivo proporcionar a continuidade do cuidado com
              a saúde do paciente.
            </p>
            <p>
              Para o paciente é possível visualizar e conceder acesso a sumário
              de alta, registros de atendimentos clínicos e resultados de exame
              realizados nos Hospitais Universitários Federais da HU Brasil.
            </p>
            <p>
              Poderão ser oferecidos no aplicativo HU Digital notificações sobre
              marcações de consulta, realização de teleconsultas e muitos mais.
              Mantenha seu aplicativo atualizado para receber os benefícios do
              HU Digital.
            </p>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
          <Typography
            style={{
              color: "#1351b4",
              fontWeight: "600",
              fontFamily: "'Raleway'",
            }}
          >
            Como faço para realizar o login no aplicativo?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography
            style={{
              color: "#555555",
              fontWeight: "400",
              fontFamily: "'Raleway'",
            }}
          >
            <p>
              Para o paciente, o acesso ao HU Digital, tanto no aplicativo
              quanto no portal Web, é realizado exclusivamente com o seu CPF e a
              senha cadastrada no gov.br. Caso seja a primeira vez utilizando o
              HU Digital e ainda não possua conta gov.br, acesse&nbsp;
              <a href="http://www.gov.br">www.gov.br</a>, faça seu cadastro. Com
              seu cadastro pronto, acesse&nbsp;
              <a href="https://hudigital.ebserh.gov.br">
                hudigital.ebserh.gov.br
              </a>
              &nbsp;ou faça download do aplicativo nas lojas Google ou Apple
              Store e realize seu login.
            </p>
            <p>
              Para maiores informações sobre como criar sua conta gov.br,&nbsp;
              <a href="http://faq-login-unico.servicos.gov.br/en/latest/">
                clique aqui
              </a>{" "}
              .
            </p>
            <p>
              Para os profissionais de saúde da Rede HU Brasil, utilize as
              mesmas credenciais de acesso utilizadas no sistema AGHUX.
            </p>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel4"}
        onChange={handleChange("panel4")}
      >
        <AccordionSummary aria-controls="panel4d-content" id="panel4d-header">
          <Typography
            style={{
              color: "#1351b4",
              fontWeight: "600",
              fontFamily: "'Raleway'",
            }}
          >
            Como faço para recuperar a senha gov.br?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography
            style={{
              color: "#555555",
              fontWeight: "400",
              fontFamily: "'Raleway'",
            }}
          >
            <p>
              Para o paciente, a recuperação de senha é realizada no portal
              acesso.gov.br. Para informações detalhadas de como proceder,&nbsp;
              <a href="http://faq-login-unico.servicos.gov.br/en/latest/_perguntasdafaq/formarrecuperarconta.html">
                clique aqui
              </a>
              &nbsp;e siga os procedimentos. Em seguida, acesse&nbsp;
              <a href="https://hudigital.ebserh.gov.br">
                hudigital.ebserh.gov.br
              </a>
              &nbsp;ou abra o aplicativo, e faça seu login.
            </p>
            <p>
              Para os profissionais de saúde da Rede HU Brasil,&nbsp;
              <a href="https://servicosti.ebserh.gov.br/">clique aqui</a>.
            </p>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel5"}
        onChange={handleChange("panel5")}
      >
        <AccordionSummary aria-controls="panel5d-content" id="panel5d-header">
          <Typography
            style={{
              color: "#1351b4",
              fontWeight: "600",
              fontFamily: "'Raleway'",
            }}
          >
            Posso utilizar o aplicativo HU Digital?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography
            style={{
              color: "#555555",
              fontWeight: "400",
              fontFamily: "'Raleway'",
            }}
          >
            <p>
              Sim, se você é um paciente da Rede HU Brasil, acesse o aplicativo
              e usufrua os serviços oferecidos.
            </p>
            <p>
              Se você é um profissional de saúde da HU Brasil, seu acesso é
              garantido com suas credenciais do sistema AGHUX.
            </p>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel6"}
        onChange={handleChange("panel6")}
      >
        <AccordionSummary aria-controls="panel6d-content" id="panel6d-header">
          <Typography
            style={{
              color: "#1351b4",
              fontWeight: "600",
              fontFamily: "'Raleway'",
            }}
          >
            Como faço para saber mais sobre os Hospitais Universitários
            Federais?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography
            style={{
              color: "#555555",
              fontWeight: "400",
              fontFamily: "'Raleway'",
            }}
          >
            <p>
              Para saber mais sobre os hospitais da Rede HU Brasil,&nbsp;
              <a href="https://www.gov.br/ebserh/pt-br/hospitais-universitarios/sobre-os-hospitais-universitarios-federais">
                acesse a página da HU Brasil
              </a>
              .
            </p>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel7"}
        onChange={handleChange("panel7")}
      >
        <AccordionSummary aria-controls="panel7d-content" id="panel7d-header">
          <Typography
            style={{
              color: "#1351b4",
              fontWeight: "600",
              fontFamily: "'Raleway'",
            }}
          >
            Quero conhecer os termos de uso e política de privacidade do HU
            Brasil. Onde posso encontrar?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography
            style={{
              color: "#555555",
              fontWeight: "400",
              fontFamily: "'Raleway'",
            }}
          >
            <p>
              Para acesso ao termo de uso e aviso de privacidade do HU
              Brasil,&nbsp;
              <a href="https://www.gov.br/ebserh/pt-br/acesso-a-informacao/tratamento-de-dados-pessoais/orientacoes-e-modelos/termo-de-uso-e-aviso-de-privacidade">
                clique aqui
              </a>
              .
            </p>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel8"}
        onChange={handleChange("panel8")}
      >
        <AccordionSummary aria-controls="panel8d-content" id="panel8d-header">
          <Typography
            style={{
              color: "#1351b4",
              fontWeight: "600",
              fontFamily: "'Raleway'",
            }}
          >
            Ainda tenho dúvidas. Como faço para entrar em contato com o HU
            Brasil?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography
            style={{
              color: "#555555",
              fontWeight: "400",
              fontFamily: "'Raleway'",
            }}
          >
            <p>
              Em caso de dúvidas,&nbsp;
              <a href="https://www.gov.br/ebserh/pt-br/acesso-a-informacao/participacao-social/ouvidoria-geral/ouvidoria">
                acesse a página da Ouvidoria da HU Brasil
              </a>
              &nbsp;e registre sua manifestação.
            </p>
          </Typography>
        </AccordionDetails>
      </Accordion>
    </>
  );
}
